import type {
  AttributeWithBooleanValueFilter,
  AttributeWithValuesFilter,
} from '@scayle/storefront-nuxt'

export const hasOnlyFilter = (
  attributes: (AttributeWithValuesFilter | AttributeWithBooleanValueFilter)[],
  filterKey: string,
) =>
  attributes.some(
    (attribute: AttributeWithValuesFilter | AttributeWithBooleanValueFilter) =>
      attribute.key === filterKey,
  ) && attributes.length === 1

export const shouldFollowRobots = (
  attributes: (AttributeWithValuesFilter | AttributeWithBooleanValueFilter)[],
  totalProductsCount: number,
) => {
  // If no filters, allow indexing
  if (!attributes.length) {
    return true
  }

  // Helper functions for better readability
  const hasMultipleFilters = attributes.length > 1
  const hasLessThanTwoProducts = totalProductsCount <= 2

  // Early return for cases that should not be indexed
  if (hasMultipleFilters || hasLessThanTwoProducts) {
    return false
  }

  // Only allow indexing for single brand or color filters
  return (
    hasOnlyFilter(attributes, 'brand') || hasOnlyFilter(attributes, 'color')
  )
}
